export type ConfirmableType = {
  fixedTariffRenewal: boolean
  smartMeterOptions: boolean
}

export type MeteringConfiguration = {
  monthlyBilling?: boolean
  dynamicTariff?: boolean
}

export enum SmartMeterOptions {
  DYNAMIC_TARIFF = 'dynamicTariff',
  MONTHLY_BILLING = 'monthlyBilling'
}

export enum SmartMeterStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  PENDING = 'pending'
}

type SmartOptionState = {
  active?: boolean
  dueDate: string
}

export type PendingMeteringChange = {
  monthlyBilling?: SmartOptionState
  dynamicTariff?: SmartOptionState
}
